export function createOrganizationFilter(
  key: 'organizationId' | 'organization.id',
  organizationId?: string,
): string[] {
  return organizationId ? [`${key}:${organizationId}-and`] : [];
}
